import React from "react";
import "./ColumnWidthPresets.css";

const WIDTH_PRESETS = [
  { key: "wide", label: "Wide", ratio: 1 },
  { key: "medium", label: "Medium", ratio: 0.7 },
  { key: "tight", label: "Tight", ratio: 0.4 },
];

const roundToHalf = (value) => Math.round(value * 2) / 2;

export default function ColumnWidthPresets({
  value,
  maxWidth,
  minWidth = 0,
  onChange,
}) {
  const currentValue = Number(value);

  return (
    <div
      className="columnWidthPresets"
      role="group"
      aria-label="Width presets"
    >
      {WIDTH_PRESETS.map(({ key, label, ratio }) => {
        const presetValue = roundToHalf(maxWidth * ratio);
        const disabled = presetValue < minWidth;
        const active = !disabled && currentValue === presetValue;

        return (
          <button
            type="button"
            key={key}
            className={`columnWidthPreset${active ? " is-active" : ""}`}
            aria-label={`${label} width (${presetValue}%)`}
            aria-pressed={active}
            title={`${label} · ${presetValue}%`}
            disabled={disabled}
            onClick={() => onChange(presetValue)}
          >
            <span
              className="columnWidthPresetTrack"
              aria-hidden="true"
            >
              <span
                className="columnWidthPresetBar"
                style={{ width: `${ratio * 100}%` }}
              />
            </span>
          </button>
        );
      })}
    </div>
  );
}
